import React from "react";

const NEW_ADMIN_URL = "https://posdirecto-admin.pagodirecto.com/login";

const NewAdminNoticeModel = ({ className }) => {
  return (
    <div className={className}>
      <p className="title">Gestión de cuentas bancarias</p>
      <p className="text">
        La creación, edición y eliminación de cuentas bancarias se mudó al nuevo
        panel de administración. Para seguir disfrutando de todas las opciones,
        ingresa al admin nuevo.
      </p>
      <a
        className="link"
        href={NEW_ADMIN_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        Ir al admin nuevo
      </a>
      <p className="url">{NEW_ADMIN_URL}</p>
    </div>
  );
};

export default NewAdminNoticeModel;

export { NEW_ADMIN_URL };
